@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/color/action";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "~@splidejs/splide/dist/css/splide-core.min.css";

.web-carousel {
    --web-carousel-slide-width: 16.5rem;
    --web-carousel-slide-gap: calc(#{spacing.$lg} - 0.6rem); // -/- .splide_slide padding
    --web-carousel-controls-background: #{color.$color-background-200};

    @media (min-width: breakpoints.$screen-desktop-min) {
        --web-carousel-slide-gap: calc(#{spacing.$xl} - 0.6rem);
    }

    .web-card {
        height: 100%;

        // loop settings makes clones that falsely retrigger stencil
        web-icon svg + svg {
            display: none;
        }
    }

    &:has(.tile-size-medium) {
        --web-carousel-slide-width: 259px;
    }

    &:has(.tile-size-large) {
        --web-carousel-slide-width: 320px;
    }

    &:not(.hydrated) .splide__list {
        gap: var(--web-carousel-slide-gap);
        // overflow-x: auto; // causes brief flash
    }

    .splide {
        .splide__slide {
            width: var(--web-carousel-slide-width);
            padding: 0.3rem;
        }

        &:not(.is-active) .splide__list {
            gap: var(--web-carousel-slide-gap);
        }

        .splide__arrows button {
            background: none;
            appearance: none;
            border: none;
            padding: 0;
        }

        &.controls-none .splide__arrows {
            display: none;
        }

        // simple controls feature big arrows at the sides of the carousel.
        &.controls-simple {
            .splide__pagination,
            .label-previous,
            .label-next {
                display: none;
            }

            .splide__arrows {
                display: flex;
                position: static;

                .splide__arrow {
                    top: 0;
                    display: flex;
                    align-items: center;
                    position: absolute;
                    height: 100%;
                    width: spacing.$xxl;
                    cursor: pointer;

                    web-icon {
                        --icon-height: #{spacing.$lg};
                        --icon-width: #{spacing.$lg};
                        color: color.$color-primary;
                    }
                }

                .splide__arrow--prev {
                    left: calc(#{spacing.$xxl} * -1);
                }

                .splide__arrow--next {
                    right: calc(#{spacing.$xxl} * -1);
                    justify-content: flex-end;
                }
            }
        }

        // full controls feature arrows and pagination below the carousel.
        &.controls-full {
            .splide__arrows {
                display: flex;
                gap: spacing.$xxl;
                flex-direction: row;
                margin: spacing.$lg auto 0;
                padding: spacing.$sm;
                max-width: max-content;
                border-radius: border-radius.$xxl;

                justify-content: center;
                align-items: center;
                background: var(--web-carousel-controls-background);
                font-size: font-size.$sm;

                ul {
                    padding: 0;
                    flex-wrap: nowrap;
                    justify-content: left;
                    overflow: hidden;
                    gap: 0.2rem;

                    button {
                        position: relative;
                        display: block;
                        width: 24px;
                        height: 24px;
                        cursor: pointer;

                        &::after {
                            content: "";
                            position: absolute;
                            display: block;
                            left: 50%;
                            top: 50%;
                            transform: scale(1) translate(-50%, -50%);
                            background-color: #bbb;
                            width: 12px;
                            aspect-ratio: 1;
                            margin: 2px;

                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 10px;
                            border-bottom-left-radius: 5px;

                            transition-property: transform, background-color;
                            transition-duration: 0.2s;
                            transition-timing-function: ease-in-out;
                            -webkit-tap-highlight-color: transparent;
                        }

                        &.is-active {
                            &::after {
                                background-color: color.$color-primary;
                                transform: scale(1.2) translate(-50%, -45%);
                            }
                        }
                    }
                }

                .splide__arrow {
                    color: action.$color-primary-normal;
                    font-family: font-family.$primary-regular;
                    font-size: font-size.$sm;
                    padding: spacing.$md-lg spacing.$sm;
                    cursor: pointer;
                    appearance: none;
                    font-weight: normal;
                    background: none;
                    border: none;
                    white-space: nowrap;

                    web-icon {
                        --icon-width: #{size.$icon-xs};
                        --icon-height: #{size.$icon-xs};
                        display: inline-flex;
                        vertical-align: middle;
                    }

                    svg {
                        margin: 0 spacing.$md;
                    }

                    &:disabled {
                        color: action.$color-primary-disabled;
                    }

                    &:not(:disabled):hover {
                        color: action.$color-primary-hover;
                    }
                }
            }
        }
    }
}
